<template>
  <div>
    <p class="mb-6 text-black-light-5" v-html="region.tagLine"></p>

    <div class="carousel-container free-style-scroll no-scrollbar -mx-6">
      <div class="container-sm">
        <carousel
          :number-of-slides="destinations.length"
          :per-page="1"
          :mouse-drag="false"
        >
          <template v-slot:default>
            <v-slide
              v-for="(destination, index) in destinations"
              :key="destination.id"
              :class="{ 'slider-last-loop': index === destinations.length - 1 }">

              <div class="slider-adaptive-height text-white">
                <div class="rounded h-full">
                  <a :href="destination.url" :title="destination.name">
                    <div class="h-full relative">
                      <div class="text-center slider-text-block rounded z-10">
                        <div>
                          <h3 class="mb-0 text-2xl font-medium">
                            {{ destination.name }}
                          </h3>
                        </div>
                      </div>

                      <img class="cover-image w-full h-full rounded"
                        :src="getCloudinaryImage(destination.image)"
                        :alt="destination.name" />
                    </div>
                  </a>
                </div>
              </div>
            </v-slide>
          </template>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from '../core/Carousel'
import { Slide } from 'vue-carousel'
import { getCloudinaryUrl } from "../../helpers";

export default {
  components: {
    Carousel,
    'v-slide': Slide
  },
  props: ['region'],
  computed: {
    destinations () {
      return this.region.children || []
    }
  },
  methods: {
    getCloudinaryImage(path){
      const origin = window.location.origin
      return getCloudinaryUrl(`${origin}${path}`, { width: 600 })
    }
  }
}
</script>

<style scoped>
.card {
  width: 200px;
}
</style>